module.exports = __webpack_public_path__ + "static/unity_img_full-c6eefb83cf8966501dd1738634b4588e.png";